/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TravelTimeMeasurement } from '../models/TravelTimeMeasurement';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TravelTimeProxyControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns string OK
     * @throws ApiError
     */
    public getPrefixes(): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/proxy/travel-time/prefixes',
        });
    }
    /**
     * @param measurementId
     * @param measurementStartDate
     * @returns TravelTimeMeasurement OK
     * @throws ApiError
     */
    public getMeasurementHistory(
        measurementId: string,
        measurementStartDate: string,
    ): CancelablePromise<Record<string, TravelTimeMeasurement>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/proxy/travel-time/measurements/{measurementId}/history',
            path: {
                'measurementId': measurementId,
            },
            query: {
                'measurementStartDate': measurementStartDate,
            },
        });
    }
}
